/**
 * AI-generated code, moderated by lzygmanski
 */
import {Building2} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'clients',
    loader: protectedLoader('ROOT', 'FULL_ACCESS'),
    children: [
      {
        index: true,
        async lazy() {
          const {ClientListPage} = await import('./pages/ClientListPage');
          return {element: <ClientListPage />};
        },
      },
      {
        path: 'add',
        async lazy() {
          const {AddClientPage} = await import('./pages/AddClientPage');
          return {element: <AddClientPage />};
        },
      },
      {
        path: 'add/success',
        async lazy() {
          const {AddClientSuccessPage} = await import(
            './pages/AddClientSuccessPage'
          );
          return {element: <AddClientSuccessPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/clients',
    text: i18n.t('Clients'),
    icon: <Building2 />,
    permission: 'FULL_ACCESS',
    entitlement: 'ROOT',
  },
] as MenuItemElement[];
